import { DialogContent, DialogTitle } from "@material-ui/core";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  Grid,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import useToast from "../../../hooks/useToast";
import {
  evaluation_refonte_reponse_service,
  evaluation_refonte_saison_service,
} from "../../../services/PersonalEvaluationRefonteService";

export const getEvaluatorOptionLabel = (
  option,
  candidateId,
  shouldShowAutoEvaluationLabel = false,
) => {
  const fullName =
    `${option?.last_name || ""} ${option?.first_name || ""}`.trim();
  const isSelfEvaluation =
    shouldShowAutoEvaluationLabel &&
    option?.user_id != null &&
    candidateId != null &&
    String(option.user_id) === String(candidateId);

  return isSelfEvaluation ? `${fullName} (auto-évaluation)` : fullName;
};

const DialogChoixFicheEvaluation = ({
  open,
  onClose,
  idCandidat,
  idSaisonActive,
  shouldShowAutoEvaluationLabel = false,
}) => {
  const { showToast, Toast } = useToast();
  const [evaluateurs, setEvaluateurs] = useState([]);
  const [selectedEvaluateur, setSelectedEvaluateur] = useState(null);
  const [currentSession, setCurrentSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  const handleClose = () => {
    setSelectedEvaluateur(null);
    onClose();
  };

  const handleFetchCurrentSession = () => {
    evaluation_refonte_saison_service.getActiveOne().then((res) => {
      if (res && res.data) {
        setCurrentSession(res.data);
      }
    });
  };

  const handleDownloadFicheEvaluation = () => {
    if (selectedEvaluateur) {
      setDownloading(true);
      evaluation_refonte_saison_service
        .downloadFicheEvaluation(
          idCandidat,
          currentSession?.ID_SAISON,
          null,
          selectedEvaluateur?.user_id,
        )
        .catch((error) => {
          showToast(
            "error",
            error?.message || "Impossible de télécharger la fiche d'évaluation",
          );
        })
        .finally(() => {
          setDownloading(false);
        });
    }
  };

  const handleFetchEvaluateurs = () => {
    setLoading(true);
    evaluation_refonte_reponse_service
      .getEvaluateurByIdCandidatAndIdSession(
        idCandidat,
        currentSession?.ID_SAISON,
        false,
      )
      .then((res) => {
        if (res) {
          const uniqueevaluateur = Array.from(
            new Set(res.data.map((e) => e.user_id)),
          ).map((id) => res.data.find((e) => e.user_id === id));
          setEvaluateurs(uniqueevaluateur);
        }
      })
      .catch((error) => {
        setEvaluateurs([]);
        showToast(
          "error",
          error?.message || "Impossible de charger les évaluateurs",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleFetchCurrentSession();
  }, [open]);

  useEffect(() => {
    if (currentSession) {
      handleFetchEvaluateurs();
    }
  }, [currentSession]);
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Télécharger fiche d'evaluation</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                options={evaluateurs}
                loading={loading}
                loadingText="Chargement..."
                getOptionLabel={(option) =>
                  getEvaluatorOptionLabel(
                    option,
                    idCandidat,
                    shouldShowAutoEvaluationLabel,
                  )
                }
                onChange={(event, value) => {
                  setSelectedEvaluateur(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choisir evaluateur"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <LoadingButton
            onClick={handleDownloadFicheEvaluation}
            variant="contained"
            color="primary"
            disabled={!selectedEvaluateur}
            loading={downloading}
          >
            Telecharger
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Toast />
    </>
  );
};

export default DialogChoixFicheEvaluation;
